export default __webpack_public_path__ + "static/media/game-start-modal-mobile.3e86be2f.png";